import React from 'react';
import ORDER_PACKING_STATUS from './constants/orderPackingStatus';
import { FormattedMessage } from 'react-intl';
import utils from '../utils/utils';

const OrderPackingStatusDisplay = ({ order }) => (
  <div>
    {order.packingStatus === ORDER_PACKING_STATUS.packed ? (
      <div className="m-b-2 alert alert-primary text-left">
        <div className="m-b-1">
          <FormattedMessage id={'packer.delivery.order.batch.row.order.packed'} />
        </div>
        {order.bagCount !== null ? (
          <div>
            <FormattedMessage
              id={'packer.delivery.order.batch.row.order.packed.bag.count'}
              values={{
                bagCount: <strong>{order.bagCount}</strong>,
              }}
            />
          </div>
        ) : (
          ''
        )}
        <div>
          <FormattedMessage
            id={'packer.delivery.order.batch.row.order.packed.order.id'}
            values={{
              id: (
                <strong>
                  #{order.batchId} {order.user.screenName}
                </strong>
              ),
            }}
          />
        </div>
        <div>
          <FormattedMessage
            id={'packer.delivery.order.batch.row.order.packed.order.time.range'}
            values={{
              timeRange: (
                <strong>
                  {utils.getFormattedTimeRange(order.timeRange)} {order.timeRange.serviceAreaName}
                </strong>
              ),
            }}
          />
        </div>
        <div>
          <FormattedMessage
            id={'packer.delivery.order.batch.row.order.packed.location'}
            values={{
              packedLocation: <strong>{order.packedLocation}</strong>,
            }}
          />
        </div>
      </div>
    ) : order.packingStatus ? (
      <div className="m-b-2 alert alert-warning text-left">
        <div className="m-b-1">
          💃{' '}
          <FormattedMessage
            id={'packer.delivery.order.batch.row.order.waiting.pre.packing'}
            values={{ id: order.id }}
          />
        </div>
      </div>
    ) : (
      ''
    )}
  </div>
);

OrderPackingStatusDisplay.propTypes = {};

OrderPackingStatusDisplay.defaultProps = {};

export default OrderPackingStatusDisplay;
